import { gql } from '@apollo/client';

export const CREATE_USER = gql`
    mutation CreateUser($name: String!, $email: String!, $division: String, $position: String, $role: String){
        createUser(
            name: $name
            email: $email
            division: $division
            position: $position
            role: $role
        ) {
            id
            name
            email
            division
            position
            role
        }
    }
`;

export const UPDATE_USER = gql`
    mutation UpdateUser($id: ID!, $name: String!, $email: String!, $division: String!, $position: String!, $role: String!){
        updateUser(
            id: $id
            name: $name
            email: $email
            division: $division
            position: $position
            role: $role
        ) {
            id
            name
            email
            division
            position
            role
        }
    }
`;

export const DELETE_USER = gql`
    mutation DeleteUser($id: ID!){
        deleteUser(
            id: $id
        ) {
            id
        }
    }
`;

export const UPDATE_USER_USERNAME = gql`
    mutation UpdateUserUsername($id: ID!, $username: String!) {
        updateUserUsername(
            id: $id
            username: $username
        ) {
            id
            username
            name
            email
        }
    }
`;

export const CREATE_LEGAL_PERSON_REFERENCE = gql`
    mutation CreateLegalPersonReference(
        $corporateNumber: String!,
        $corporateName: String!,
        $corporateAddress: String!,
        $representativeName: String!,
        $applicantPhone: String
    ) {
        createLegalPersonReference(
            corporateNumber: $corporateNumber
            corporateName: $corporateName
            corporateAddress: $corporateAddress
            representativeName: $representativeName
            applicantPhone: $applicantPhone
        )
    }
`;
